import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { toast } from "@/components/ui/use-toast";
import { copyToClipboard } from "@/lib/js-helpers/copyToClipboard";
import { AnimatePresence } from "framer-motion";
import { Copy, Menu, Trash2 } from "lucide-react";
import { useState } from "react";
import { generateStandingOfferURL } from "../../utils/generateStandingOfferURL";
import { CancelStandingOffer } from "./CancelStandingOffer";
import { CopyStandingOfferURL } from "./CopyStandingOfferURL";

export function StandingOfferActions({ id }: { id: string }) {
  const [openCancelOffer, setOpenCancelOffer] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false);

  function handleCopy() {
    const offerURL = generateStandingOfferURL(id);

    copyToClipboard(offerURL)
      .then(() =>
        toast({
          title: "URL copied",
          description:
            "The url to the offer page has been copied to the clipboard"
        })
      )
      .catch((error) => {
        setOpenCopyModal(true);
        console.error(error);
      });
  }

  return (
    <>
      <div className='flex justify-end pr-2 invisible group-hover:visible [&>button[data-state="open"]]:visible'>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon">
              <span className="sr-only">Open menu</span>
              <Menu size={14} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem className="gap-2" onClick={handleCopy}>
              <Copy size={14} />
              Copy offer url
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="gap-2"
              destructive
              onClick={() => setOpenCancelOffer(true)}
            >
              <Trash2 size={14} />
              Cancel offer
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <AnimatePresence>
        {openCancelOffer && (
          <CancelStandingOffer
            id={id}
            onOpenChange={() => setOpenCancelOffer(false)}
          />
        )}
        {openCopyModal && (
          <CopyStandingOfferURL
            id={id}
            onOpenChange={() => setOpenCopyModal(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
}
